import { NavItem, SidenavRoleType, SidenavType } from './sidenav.component';

export const SIDENAV_MAPPING: Record<
  SidenavType,
  Record<SidenavRoleType, string[]>
> = {
  admin: {
    system_admin: [
      'device',
      'device_type',
      'tenant',
      'notifications',
      'account',
    ],
    tenant_admin: [], // 実装上使用しないが型を合わせるために指定する
    tenant_editor: [], // 実装上使用しないが型を合わせるために指定する
    tenant_viewer: [], // 実装上使用しないが型を合わせるために指定する
  },
  tenant: {
    system_admin: ['dashboard', 'device_info', 'shipment', 'asset_type'],
    tenant_admin: [
      'dashboard',
      'device_info',
      'device_setting',
      'shipment',
      'shipment_setting',
      'asset_type',
      'account',
      'audit_log',
      'site',
    ],
    tenant_editor: [
      'dashboard',
      'device_info',
      'device_setting',
      'shipment',
      'shipment_setting',
      'asset_type',
    ],
    tenant_viewer: ['dashboard', 'device_info', 'shipment'],
  },
};

export const SIDENAV_ITEMS: { [key: string]: NavItem } = {
  dashboard: {
    type: 'link',
    icon: 'home',
    name: 'ダッシュボード',
    path: '/dashboard',
  },
  device_info: {
    type: 'link',
    icon: 'stay_current_portrait',
    name: 'デバイス情報',
    path: '/device-info',
  },
  device_setting: {
    type: 'link',
    icon: 'phonelink_setup',
    name: 'デバイス設定',
    path: '/device-settings',
  },
  device: {
    type: 'link',
    icon: 'devices',
    name: 'デバイス管理',
    path: '/devices',
  },
  device_type: {
    type: 'link',
    icon: 'box_add',
    name: 'デバイス種類',
    path: '/device-types',
  },
  shipment: {
    type: 'link',
    icon: 'local_shipping',
    name: '配送情報',
    path: '/shipment-info',
  },
  shipment_setting: {
    type: 'menu',
    icon: 'route',
    name: '配送設定',
    path: '/shipments',
    children: [
      {
        type: 'link',
        name: '配送設定',
        icon: '',
        path: '/shipments',
      },
      {
        type: 'link',
        name: '位置情報設定',
        icon: '',
        path: '/shipments/locations',
      },
    ],
  },
  asset_type: {
    type: 'link',
    icon: 'list_alt_add',
    name: '設定テンプレ',
    path: '/setting-templates',
  },
  tenant: {
    type: 'link',
    icon: 'add_business',
    name: 'テナント管理',
    path: '/tenants',
  },
  account: {
    type: 'link',
    icon: 'manage_accounts',
    name: 'アカウント管理',
    path: '/accounts',
  },
  audit_log: {
    type: 'link',
    icon: 'frame_inspect',
    name: 'ログ管理',
    path: '/audit-logs',
  },
  site: {
    type: 'link',
    icon: 'settings',
    name: 'テナント設定',
    path: '/tenant-settings',
  },
  notifications: {
    type: 'link',
    icon: 'notification_add',
    name: '掲示板管理',
    path: '/notifications',
  },
} as const;
